import definedAbility from "@/ability";

export const dripWrapper = {
  push: dripData => {
    // Drip can be disabled via env
    if (process.env.VUE_APP_DRIP_ENABLED !== "true") return;
    // Drip events disabled for inulti users.
    if (!definedAbility().can("use", "drip tracking")) return;
    window._dcq && window._dcq.push(dripData);
  },
};

export const dripPlugin = {
  install: Vue => {
    Vue.prototype.drip = dripWrapper;
  },
};
